export const ORDER_REVIEW = "ORDER_REVIEW";
export const orderReviewAction = (data) => {
    return {
        type: ORDER_REVIEW,
        payload: data
    }
}